import React from "react";
import AdminInterestsTable from "../../components/AdminInterestsTable";

const ManageInterests: React.FC = () => {
  return (
    <div className="p-6">
      <AdminInterestsTable />
    </div>
  );
};

export default ManageInterests;
